const rankings = [
  { rank: 1, title: '长相思', tag: '古装玄幻', heat: '热度 9.8', change: 'up', desc: '杨紫张晚意年度巨制' },
  { rank: 2, title: '庆余年 第二季', tag: '古装权谋', heat: '热度 9.7', change: 'up', desc: '张若昀原班人马回归' },
  { rank: 3, title: '你比星光美丽', tag: '都市爱情', heat: '热度 9.5', change: 'up', desc: '谭松韵许凯甜蜜搭档' },
  { rank: 4, title: '与凤行', tag: '仙侠奇幻', heat: '热度 9.3', change: 'same', desc: '赵丽颖林更新再合作' },
  { rank: 5, title: '繁花', tag: '年代商战', heat: '热度 9.1', change: 'down', desc: '王家卫导演首部剧集' },
  { rank: 6, title: '玫瑰的故事', tag: '都市情感', heat: '热度 8.8', change: 'up', desc: '刘亦菲演绎女性成长' },
  { rank: 7, title: '大江大河3', tag: '年代励志', heat: '热度 8.6', change: 'same', desc: '王凯杨烁董子健主演' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="relative py-16 md:py-20 bg-background-950">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-accent-500/3 rounded-full blur-3xl"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-trophy-line text-accent-400 text-xs"></i>
            <span className="text-accent-300 text-xs font-medium">热播榜单</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50">
            本周热播 TOP 7
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-lg mx-auto">
            根据播放量与讨论热度综合排名，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {rankings.map((item, i) => (
            <div
              key={i}
              className="group relative flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-900/80 border border-background-800/60 hover:border-primary-500/20 hover:bg-background-800/80 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-9 h-9 md:w-10 md:h-10 rounded-xl flex items-center justify-center font-heading font-bold text-sm shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-primary-400 text-background-50'
                  : item.rank === 3
                  ? 'bg-primary-300 text-background-50'
                  : 'bg-background-700 text-foreground-300'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading font-bold text-sm md:text-base text-background-50 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <span className="px-2 py-0.5 rounded-md bg-background-700 text-foreground-300 text-[10px]">
                    {item.tag}
                  </span>
                </div>
                <p className="mt-0.5 text-xs text-foreground-400">{item.desc}</p>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                <span className="text-xs font-medium text-primary-400">{item.heat}</span>
                <i className={`text-sm ${
                  item.change === 'up'
                    ? 'ri-arrow-up-line text-accent-500'
                    : item.change === 'down'
                    ? 'ri-arrow-down-line text-red-400'
                    : 'ri-subtract-line text-foreground-400'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}